// these are used to wrap the dynamic fields array so that they can be replaced automatically later in the app
export const specialWrapperStart = "{(";
export const specialWrapperEnd = ")}";

export const backgroundImageName = "backgroundImage";
